<template>
  <div>
    <div class="loader"></div>
    <span>Please wait for your information to be uploaded to the server.
      LP investments will be ignored. It will be added in next release
    </span>
  </div>
</template>
<script>
export default {
  name: "notification-sample",
};
</script>
<style>
.loader {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
